<template>
  <div class="demo">
    <div class="demo-header">
      <h1 class="demo-header-text">Introduction to Brainpeek!</h1>
      <div class="demo-byline">
        A quick explanation of the the most important parts of a Brainpeek test
      </div>
      <bg-button
        class="action"
        text="Continue to test"
        @click="redirectToDemo()"
      />
    </div>
    <div class="info-holder">
      <div
        :key="explanation.name"
        v-for="explanation in explanations"
        class="info-box"
      >
        <img
          :src="images[explanation.image]"
          alt="tutorial image"
          class="info-image"
        />
        <div class="info-content">
          <div class="info-title">{{ explanation.title }}</div>
          <div class="info-text">
            {{ explanation.text }}
            <a class="link" :href="explanation.link">{{ ` Read more.` }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.demo-header-text {
  font-size: 40px;
  font-weight: 800;
  margin-bottom: 10px;
}
.demo-byline {
  font-size: 18px;
  margin-bottom: 40px;
}
.info-holder {
  display: flex;
  flex-direction: column;
}
.info-box {
  padding: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  flex-grow: 1;
  margin-bottom: 20px;
}
.info-content {
  padding: 0 40px;
}

.link {
  color: var(--bg-color-text-link);
}
.info-image {
  width: 40%;
  height: 40%;
  margin-bottom: 20px;
}
.info-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}
.info-text {
  font-size: 14px;
  margin-bottom: 40px;
}
</style>

<script>
import BgButton from "@/components/bg-button";
import BgIcon from "@/components/bg-icon";
import BgLogo from "@/components/bg-logo";

import API from "@/api";
import { mapState } from "vuex";

export default {
  name: "account",
  components: {
    BgButton,
    BgLogo,
    BgIcon,
  },
  methods: {
    redirectToDemo() {
      if (this.$route.query.type === "video") {
        this.$router.push(`/video-test/${this.$route.params.id}/summary/`);
      } else {
        this.$router.push(`/test/${this.$route.params.id}/overview/`);
      }
    },
  },
  data() {
    return {
      images: {
        benchmark: require("@/assets/imgs/demo/benchmark.png"),
        elements: require("@/assets/imgs/demo/elements.png"),
        emotions: require("@/assets/imgs/demo/emotions.png"),
        neurofeedback: require("@/assets/imgs/demo/neurofeedback.png"),
        screenEye: require("@/assets/imgs/demo/screen&eye.png"),
        pageinsights: require("@/assets/imgs/demo/pageinsights.png"),
        journeyinsights: require("@/assets/imgs/demo/journeyinsights.png"),
      },
      explanations: [
        {
          image: "emotions",
          title: "Emotions and significant points",
          text: "Increases in the three emotions (frustration, joy, and attention) are marked by a circle called significant point.",
          link: "www.google.com",
        },
        {
          image: "screenEye",
          title: "Screen recording and eye tracking",
          text: "For each participant there is a screen recording of their behavior during the test. On this recording you’ll see red dots, which represent the eye movements of the participant.",
          link: "www.google.com",
        },
        {
          image: "neurofeedback",
          title: "Neurofeedback",
          text: "The significant points are complemented with feedback from the participant, after the test was performed.",
          link: "www.google.com",
        },
        {
          image: "elements",
          title: "Elements",
          text: "Every neurofeedback will be tagged with the element that is related to. In Elements you will see an overview of all the elements and their neurofeedback.",
          link: "www.google.com",
        },
        {
          image: "journeyinsights",
          title: "Sections",
          text: "Average emotions scores based on 10 participants are calculated for each section. Sections will show you an overview of the top 10 sections.",
          link: "www.google.com",
        },
        {
          image: "pageinsights",
          title: "Section insights",
          text: "Section insights provides more in-depth statistics such as: section performance, average emotions, clicks and time to complete.",
          link: "www.google.com",
        },
      ],
    };
  },
};
</script>
